export enum StowagePlanTypeEnum {
    Draft,
    Published,
    Master,
}
